module.exports = __webpack_public_path__ + "static/media/flexibilidade_7.40cac987.jpg";